import { Routes, Route } from "react-router-dom";
import WaterLevels from "./WaterLevels";

const index = () => {
	return (
		<Routes>
			<Route index element={<WaterLevels />} />
		</Routes>
	);
};

export default index;
